import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, Select } from 'antd';

import { MultipleSelect } from '@app/components';
import { PF } from '@app/pages/Warehouses/PurchasePlanningSettings/data';
import type { PurchasePlanningSettingsFiltersType } from '@app/pages/Warehouses/PurchasePlanningSettings/types';

const FILTERS = `${PF}_filters`;

export const Filters: PurchasePlanningSettingsFiltersType = ({
  disabled,
  onSearch,
  onReset,
  productCategoriesOptions,
  warehousesOptions,
  values: { warehouseId, search, categories },
  onFiltersChange,
}) => (
  <div className={`${FILTERS}_container`}>
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите название, штрихкод или артикул товара"
      value={search}
      onChange={(e) => onFiltersChange('search', e.target.value)}
      onPressEnter={onSearch}
      className={`${FILTERS}_search`}
      disabled={disabled}
      allowClear
    />

    <div className={`${FILTERS}_toolbar`}>
      <div className={`${FILTERS}_selects`}>
        <MultipleSelect
          className={`${FILTERS}_select`}
          placeholder="Все категории"
          allOptions={productCategoriesOptions}
          selectedOption={categories}
          setSelectedOptions={(opts) => onFiltersChange('categories', opts)}
          disabled={disabled}
        />
        <Select<number>
          showSearch
          optionFilterProp="label"
          className={`${FILTERS}_select`}
          placeholder="Выберите склад"
          options={warehousesOptions}
          disabled={disabled}
          value={warehouseId}
          onChange={(val) => onFiltersChange('warehouseId', val)}
        />
      </div>
      <div className={`${FILTERS}_buttons`}>
        <Button
          htmlType="reset"
          onClick={onReset}
          className={`${FILTERS}_buttons_item`}
          disabled={disabled}
        >
          <CloseCircleOutlined />
          Сброс
        </Button>
        <Button
          type="primary"
          onClick={onSearch}
          className={`${FILTERS}_buttons_item`}
          disabled={disabled}
        >
          Показать
        </Button>
      </div>
    </div>
  </div>
);
